const autoNgTemplateLoaderTemplate1 = require('./ssl-certificate.html');

import controller from './ssl-certificate.controller.js';

export const sslCertificate = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
